import { c as _c } from "react/compiler-runtime";
import type { CouponId, CouponIndex } from '@svs/nova-poolbetting/schema/coupon';
import type { ReactNode } from 'react';
import BetButtonsColumnClientContainer from './BetButtonsColumnClientContainer';

/**
 * Props for the BetButtons component.
 * Contains the coupon identification and indices for rendering bet button columns.
 */
type BetButtonsProps = {
  /** Array of coupon indices that determine which columns to render */
  couponIndices: CouponIndex[];
  /** Unique identifier for the coupon */
  couponId: CouponId;
};

/**
 * Component that renders columns of bet buttons for a coupon.
 *
 * Creates a responsive grid layout with alternating background colors for bet button columns.
 * Each column represents a set of betting options for the specified coupon.
 *
 * @param props - The component props
 * @param props.couponIndices - Array of coupon indices that determine which columns to render
 * @param props.couponId - Unique identifier for the coupon
 * @returns JSX element containing the bet buttons grid layout
 */
export default function BetButtons(t0) {
  const $ = _c(8);
  const {
    couponIndices,
    couponId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["[&>*:nth-child(odd)]:bg-layer-neutral", "row-span-9", "row-start-1", "grid", "grid-flow-col", "auto-cols-min", "grid-rows-subgrid", "overflow-auto"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const classNames = t1;
  const t2 = classNames.join(" ");
  let t3;
  if ($[1] !== couponId || $[2] !== couponIndices) {
    let t4;
    if ($[4] !== couponId) {
      t4 = couponIndex => <BetButtonsColumnClientContainer key={couponIndex} couponIndex={couponIndex} couponId={couponId} />;
      $[4] = couponId;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t3 = couponIndices.map(t4);
    $[1] = couponId;
    $[2] = couponIndices;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}